import { render, staticRenderFns } from "./btn-text-secondary3.vue?vue&type=template&id=6d6ce744&scoped=true"
import script from "./btn-text-secondary3.vue?vue&type=script&lang=js"
export * from "./btn-text-secondary3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d6ce744",
  null
  
)

export default component.exports